import LoadMore from './LoadMore';

const els = document.querySelectorAll('.js-load-more');

for (let el of els) {
    new LoadMore(el);
}
